/** @module SiteAdmin/Lookup/EditSpecificationItem */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Request",
	"csi/locale",
	"csi/reflection",
	"csi/table/Edit",
	"./SpecificationItemMixin"
], function (declare, lang, Request, locale, reflection, Edit, SpecificationItemMixin) {

	return declare([Edit, SpecificationItemMixin], {

		/*
		 * @override
		 * Return to appropriate server operation
		 */
		_getActionRequest: function () {
			return lang.mixin(new Request(), {
				m_module: "SpecificationDataSheet",
				m_operation: "EditSpecificationItemDefinition"
			});
		},

		/*
		 * @override
		 * Populate the values while editing for Value Attribute Fields
		 */
		onCreatePopup: function (view) {
			var node = this.getNode();
			view.addFixedValue("Subtype", node.Subtype);
			var vad = view.cacheView.getNode(node.ValueAttributeDefinition);
			var valType = vad ? vad.ValueType : "";
			var format = vad ? vad.Format : "";
			var lookup = vad ? vad.LookupItemSubtype : "";
			var expr = vad ? vad.ValidationExpression : "";
			var errMsg = vad ? vad.ValidationErrorMessage : "";
			view.addFixedValue(reflection.ATTR_VALUETYPE, valType);
			view.addFixedValue(reflection.ATTR_FORMAT, format);
			view.addDefaultValue(this.LOOKUP_ITEM_SUBTYPE, lookup);
			view.addDefaultValue(this.VALIDATION_EXPRESSION, expr);
			view.addDefaultValue(this.VALIDATION_ERROR_MESSAGE, errMsg[locale.getLocale()]);
			this.inherited(arguments);
		}
	});
});
